export type CompanyStatusTone = 'success' | 'warning' | 'danger' | 'neutral';

export interface CompanyStatusMeta {
    label: string;
    tone: CompanyStatusTone;
}

const STATUS_MAP: Record<string, CompanyStatusMeta> = {
    active: {label: 'Approvata', tone: 'success'},
    approved: {label: 'Approvata', tone: 'success'},
    inactive: {label: 'Disattivata', tone: 'danger'},
    deleted: {label: 'Eliminata', tone: 'neutral'},
    pendingApprovation: {label: 'In attesa di approvazione', tone: 'warning'},
    approving: {label: 'Approvazione in corso', tone: 'warning'},
    pendingOnboarding: {label: 'Onboarding in corso', tone: 'warning'},
    pendingOnboardingOtp: {label: 'OTP onboarding', tone: 'warning'},
    pendingOtp: {label: 'In attesa di OTP', tone: 'warning'},
    pendingPayment: {label: 'In attesa di pagamento', tone: 'warning'},
    paymentFailed: {label: 'Pagamento non riuscito', tone: 'danger'},
};

export function getCompanyStatusMeta(status?: string | null): CompanyStatusMeta {
    const key = (status ?? '').trim();
    if (!key) {
        return {label: 'Stato non disponibile', tone: 'neutral'};
    }
    return STATUS_MAP[key] ?? {label: key, tone: 'neutral'};
}

export function isCompanyPendingApproval(status?: string | null): boolean {
    return (status ?? '').trim() === 'pendingApprovation';
}
